import { IUserNotificationsItem } from '../../interfaces/user-notifications.interface'

export interface UserNotificationsStateModel {
  notifications: IUserNotificationsItem[]
}
